import actionsList from './actionsList'
export const setUserToken = (token, expireAt) => ({type: actionsList.SET_TOKEN, token, expireAt});
